<template>
  <div class="info-container">
    <!-- 顶部导航栏 -->
    <div class="nav-tabs">
        <h4 class="nav-item" @click="clickTab(item.tab)" :class="item.tab == tab?'active':''" v-for="item in menuList">{{item.title}}</h4>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoMenu',
  props:{
    menuList:{
      type: Array,
      default: function () {
        return []
      }
    },
    tab:{
      type: Number,
      default: 1
    }
  },methods:{
    clickTab(tab){
      if(tab===this.tab){
        return;
      }
      this.$emit('change',{leftTab:tab});
    }
  },
}
</script>
<style lang="less" scoped>

.nav-tabs {
  margin-bottom: 16px;
  display: flex;
  gap: 36px;
  padding: 18px 0 0 0;
  border-bottom: 1px solid #E6EDF5;
  margin-left: 18px;
}

.nav-item {
  padding-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
  color: #333;
  //font-weight: bold;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
}
.nav-item.active{
  color: #2A82E4;
}
.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 25%; /* 100% - 50% = 50%，左右各25% */
  width: 50%; /* 只显示一半 */
  height: 4px;
  background-color: #2A82E4;
  border-radius: 1px; /* 可选：让线条两端圆润 */
}


</style>